module.exports = __webpack_public_path__ + "static/Portrait-of-Anders-min-56cacd061c731438f76ec1cc96ff0ae2.jpg";